import { useTranslation } from 'react-i18next';

import styles from './Criteria.module.css';
import { StrengthTag } from './StrengthTag';
import type { CriterionKey, CriterionRow } from './useCriteriaRows';

interface CriteriaRowListProps {
  rows: Record<CriterionKey, CriterionRow>;
  order: readonly CriterionKey[];
}

/**
 * Список критериев с метками обязательно / желательно / без предпочтений.
 *
 * Показывается только то, что уже известно: пустые строки «ещё не уточняли»
 * заняли бы панель списком того, чего нет, — что осталось уточнить, видно по
 * реплике консультанта и строке готовности.
 */
export function CriteriaRowList({ rows, order }: CriteriaRowListProps) {
  const { t } = useTranslation();
  const visible = order.map((key) => rows[key]).filter((row) => row.value !== null);

  if (visible.length === 0) {
    return <p className={styles.empty}>{t('criteria.panel.empty')}</p>;
  }

  return (
    <dl className={styles.rows}>
      {visible.map((row) => (
        <div key={row.key} className={styles.row}>
          <dt className={styles.rowLabel}>
            {t(row.labelKey)}
            <StrengthTag strength={row.strength} />
          </dt>
          <dd className={styles.rowValue}>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
